module.exports = __webpack_public_path__ + "img/cloud-upload.fe25a364.svg";